/* eslint no-async-promise-executor: 0 */ // --> OFF
import { app } from './main'
import axios from 'axios'
import { getToken, generateToken, validateToken } from './sessionStorage'
import { empty } from '@/helpers'

/*
params:{
    "url":"",
    "params":{},
    "method": "POST"|"GET"|"PUT"|"DELETE",
    "validate": true|false
}
*/

export async function request (params) {
  return new Promise(async function (resolve, reject) {
    const url = params.url || ''
    const data = params.params || ''
    const method = params.method || 'GET'
    let validate = params.validate
    const apiURL = process.env.VUE_APP_API_URL || ''
    const config = {
      headers: {
        Authorization: '',
        Verification: ''
      }
    }
    let token = ''
    if (params.validate === undefined) validate = true
    config.headers.Verification = app.$store.state.pass
    app.$store.dispatch('setPass', '')
    if (validate) {
      if (!validateToken()) {
        token = await generateToken()
      } else token = getToken()
      config.headers.Authorization = `Bearer ${token}`
    }

    switch (method) {
      case 'GET': {
        app.$vs.loading()
        let tempdata = '?'
        for (const prop in data) {
          if (!empty(data[prop])) tempdata += `${prop}=${data[prop]}&`
        }
        tempdata = tempdata.slice(0, -1)
        axios.get(`${apiURL + url}${tempdata}`, config)
          .then(response => {
            resolve(response)
          }).catch(error => {
            if (error.response.data.code === 401) {
              app.$vs.notify({
                title: app.$t('Messages.Fail'),
                position: 'top-center',
                time: 8000,
                text: app.$t('Messages.Sesion'),
                color: 'danger',
                icon: 'warning'
              })
              setTimeout(time => {
                app.$cookies.remove('session')
                app.$router.push('/login')
              }, 1500)
            }
            reject(error)
          }).finally(() => {
            app.$vs.loading.close()
          })
        break
      }
      case 'POST': {
        app.$vs.loading()
        axios.post(`${apiURL}${url}`,
          data, config)
          .then(response => {
            app.$vs.notify({
              title: app.$t('Messages.Success'),
              position: 'top-center',
              time: 8000,
              text: (url === 'login' ? app.$t('WelcomeMessage') : app.$t('Messages.AddSuccess')),
              color: 'success',
              icon: 'done'
            })
            resolve(response)
          }).catch(error => {
            if (error.response.data.code === 401) {
              app.$vs.notify({
                title: app.$t('Messages.Fail'),
                position: 'top-center',
                time: 8000,
                text: app.$t('Messages.Sesion'),
                color: 'danger',
                icon: 'warning'
              })
              setTimeout(time => {
                app.$cookies.remove('session')
                app.$router.push('/login')
              }, 1500)
            }
            app.$vs.notify({
              title: app.$t('Messages.Fail'),
              position: 'top-center',
              time: 8000,
              text: app.$t('Messages.FailMessage'),
              color: 'danger',
              icon: 'warning'
            })
            reject(error)
          }).finally(() => {
            app.$vs.loading.close()
          })
        break
      }
      case 'PUT': {
        app.$vs.loading()
        axios.put(`${apiURL}${url}`,
          data, config)
          .then(response => {
            app.$vs.notify({
              title: app.$t('Messages.Success'),
              position: 'top-center',
              time: 8000,
              text: app.$t('Messages.UpdateSuccess'),
              color: 'success',
              icon: 'done'
            })
            resolve(response)
          }).catch(error => {
            if (error.response.data.code === 401) {
              app.$vs.notify({
                title: app.$t('Messages.Fail'),
                position: 'top-center',
                time: 8000,
                text: app.$t('Messages.Sesion'),
                color: 'danger',
                icon: 'warning'
              })
              setTimeout(time => {
                app.$cookies.remove('session')
                app.$router.push('/login')
              }, 1500)
            }
            app.$vs.notify({
              title: app.$t('Messages.Fail'),
              position: 'top-center',
              time: 8000,
              text: app.$t('Messages.FailUpdate'),
              color: 'danger',
              icon: 'warning'
            })
            reject(error)
          }).finally(() => {
            app.$vs.loading.close()
          })
        break
      }
      case 'DELETE': {
        app.$vs.loading()
        config.data = data
        axios.delete(`${apiURL}${url}`, config)
          .then(response => {
            app.$vs.notify({
              title: app.$t('Messages.Success'),
              position: 'top-center',
              time: 8000,
              text: app.$t('Messages.DeleteSuccess'),
              color: 'success',
              icon: 'done'
            })
            resolve(response)
          }).catch(error => {
            if (error.response.data.code === 401) {
              app.$vs.notify({
                title: app.$t('Messages.Fail'),
                position: 'top-center',
                time: 8000,
                text: app.$t('Messages.Sesion'),
                color: 'danger',
                icon: 'warning'
              })
              setTimeout(time => {
                app.$cookies.remove('session')
                app.$router.push('/login')
              }, 1500)
            }
            app.$vs.notify({
              title: app.$t('Messages.Fail'),
              position: 'top-center',
              time: 8000,
              text: app.$t('Messages.FailDelete'),
              color: 'danger',
              icon: 'warning'
            })
            reject(error)
          }).finally(() => {
            app.$vs.loading.close()
          })
        break
      }
      case 'FILE': {
        app.$vs.loading()
        axios({
          url: `${apiURL}${url}`,
          method: 'GET',
          responseType: 'blob',
          headers: config.headers
        }).then((response) => {
          resolve(response)
        }).catch(error => {
          if (error.response.data.code === 401) {
            app.$vs.notify({
              title: app.$t('Messages.Fail'),
              position: 'top-center',
              time: 8000,
              text: app.$t('Messages.Sesion'),
              color: 'danger',
              icon: 'warning'
            })
            setTimeout(time => {
              app.$cookies.remove('session')
              app.$router.push('/login')
            }, 1500)
          }
          app.$vs.notify({
            title: app.$t('Messages.Fail'),
            position: 'top-center',
            time: 8000,
            text: app.$t('Messages.Fail'),
            color: 'danger',
            icon: 'warning'
          })
          reject(error)
        }).finally(() => {
          app.$vs.loading.close()
        })
        break
      }
      default:
        break
    }
  })
}
